import { Product } from "./models/Product";

export class ProductUseCase {
  static datas: Product[] = [
    {
      id: 1,
      name: "Item 1"
    },
    {
      id: 2,
      name: "Item 2"
    }
  ];

  public async getProducts(): Promise<Product[]> {
    return Promise.resolve(ProductUseCase.datas);
  }
}
